import * as React from 'react';
import styled from 'styled-components';
import { ErrorImage } from '../../components/04error/errorImageComponent';
import { ErrorMessage } from '../../components/04error/errorMessageComponent';
import { InvalidMessage } from "../../components/04error/invalidMessage";

type Props = {
    // languageExchange:any,
}

export const InvalidPage: React.FC<Props> = (props) => {
  const ErrorPageComponent = styled.main`
    text-align: center;
    background-color: #555555;
    color: white;
    font-family: 'Noto Sans JP',sans-serif;
    font-style: normal;

    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    height: 100vh;
  `;
  return (
    <ErrorPageComponent>
         <div>
            <ErrorImage/>
            <InvalidMessage/>
        </div>
    </ErrorPageComponent>
  );
};